// Canonical TName → player-facing name lookup. Generated from
// hsh-documents/TNames - TName_Indexes.csv (the authoritative source;
// Constants.js Texture.NAMES has stale internal labels — Arena/Zoo/
// Robot/Pirate — and must NOT be used for player copy). If the CSV
// changes, regenerate this file from it.
//
// TEXTURE_NAMES[tname] === player-facing string, e.g.
//   TEXTURE_NAMES[5]  === 'Upgraded Action Room Staff'  (CSV says Staff,
//                          not the stale "Robot" in Constants.js)
//   TEXTURE_NAMES[16] === 'Amenity Room Casino'
//   TEXTURE_NAMES[126] === 'Snohe'
export const TEXTURE_NAMES = {
    0: 'Empty Room',
    1: 'Upgraded Action Room Research',
    2: 'Action Room Research',
    3: 'Upgraded Action Room Lodging',
    4: 'Action Room Lodging',
    5: 'Upgraded Action Room Staff',
    6: 'Action Room Staff',
    7: 'Upgraded Action Room Renovation',
    8: 'Action Room Renovation',
    9: 'Upgraded Action Room Advertisement',
    10: 'Action Room Advertisement',
    11: 'Upgraded Action Room Ghost',
    12: 'Action Room Ghost',
    13: 'Upgraded Amenity Room Observatory',
    14: 'Amenity Room Observatory',
    15: 'Upgraded Amenity Room Casino',
    16: 'Amenity Room Casino',
    17: 'Upgraded Amenity Room Theater',
    18: 'Amenity Room Theater',
    19: 'Upgraded Amenity Room Bar',
    20: 'Amenity Room Bar',
    21: 'Upgraded Amenity Room Altar',
    22: 'Amenity Room Altar',
    23: 'Upgraded Amenity Room Menagerie',
    24: 'Amenity Room Menagerie',
    25: 'Upgraded Bed Room Deep',
    26: 'Bed Room Deep',
    27: 'Upgraded Bed Room Stem',
    28: 'Bed Room Stem',
    29: 'Upgraded Bed Room Hex',
    30: 'Bed Room Hex',
    31: 'Upgraded Bed Room Dread',
    32: 'Bed Room Dread',
    33: 'Upgraded Bed Room Honored',
    34: 'Bed Room Honored',
    35: 'Upgraded Bed Room Seed',
    36: 'Bed Room Seed',
    37: 'Upgraded Lodging Deep',
    38: 'Lodging Deep',
    39: 'Upgraded Lodging Stem',
    40: 'Lodging Stem',
    41: 'Upgraded Lodging Hex',
    42: 'Lodging Hex',
    43: 'Upgraded Lodging Dread',
    44: 'Lodging Dread',
    45: 'Upgraded Lodging Honored',
    46: 'Lodging Honored',
    47: 'Upgraded Lodging Seed',
    48: 'Lodging Seed',
    49: 'Dread Weakness Room',
    50: 'Honored Weakness Room',
    51: 'Seed Weakness Room',
    52: 'Deep Weakness Room',
    53: 'Stem Weakness Room',
    54: 'Hex Weakness Room',
    55: 'Random Room',
    56: 'Snohe Crash',
    57: 'Upgraded Generic Bed Room',
    58: 'Generic Bed Room',
    59: 'Faction Action Deep',
    60: 'Faction Action Stem',
    61: 'Faction Action Hex',
    62: 'Faction Action Dread',
    63: 'Faction Action Honored',
    64: 'Faction Action Seed',
    65: 'Faction Action Research',
    66: 'Faction Action Lodging',
    67: 'Faction Action Staff',
    68: 'Faction Action Renovation',
    69: 'Faction Action Advertisement',
    70: 'Faction Action Ghost',
    71: 'Action Research',
    72: 'Action Lodging',
    73: 'Action Staff',
    74: 'Action Renovation',
    75: 'Action Advertisement',
    76: 'Action Ghost',
    77: 'Faction Deep',
    78: 'Faction Stem',
    79: 'Faction Hex',
    80: 'Faction Dread',
    81: 'Faction Honored',
    82: 'Faction Seed',
    83: 'Random Action Selector',
    84: 'Deep Scientist',
    85: 'Deep Vanguard',
    86: 'Deep Thespian',
    87: 'Deep Patron',
    88: 'Deep Worshiper',
    89: 'Deep Seeker',
    90: 'Stem Scientist',
    91: 'Stem Vanguard',
    92: 'Stem Thespian',
    93: 'Stem Patron',
    94: 'Stem Worshiper',
    95: 'Stem Seeker',
    96: 'Hex Scientist',
    97: 'Hex Vanguard',
    98: 'Hex Thespian',
    99: 'Hex Patron',
    100: 'Hex Worshiper',
    101: 'Hex Seeker',
    102: 'Dread Scientist',
    103: 'Dread Vanguard',
    104: 'Dread Thespian',
    105: 'Dread Patron',
    106: 'Dread Worshiper',
    107: 'Dread Seeker',
    108: 'Honored Scientist',
    109: 'Honored Vanguard',
    110: 'Honored Thespian',
    111: 'Honored Patron',
    112: 'Honored Worshiper',
    113: 'Honored Seeker',
    114: 'Seed Scientist',
    115: 'Seed Vanguard',
    116: 'Seed Thespian',
    117: 'Seed Patron',
    118: 'Seed Worshiper',
    119: 'Seed Seeker',
    120: 'Upgraded Ghost',
    121: 'Ghost',
    122: 'Suk Cur',
    123: 'Lodging Wheel',
    124: 'Pirate Wheel',
    125: 'Action Hex',
    126: 'Snohe',
    127: 'Snohe Three',
    128: 'Snohe Five',
    129: 'Snohe Ten',
    130: 'Relic',
    131: 'Chest',
    132: 'Vendor',
    133: 'Mystery',
    134: 'Boss',
    135: 'Competition',
    136: 'Bank',
    137: 'Deep Captain',
    138: 'Stem Captain',
    139: 'Hex Captain',
    140: 'Dread Captain',
    141: 'Honored Captain',
    142: 'Seed Captain',
    143: 'Ley Space',
    144: 'Zygnus',
    145: 'Meganism',
    146: 'Llolooloo',
    147: 'Megan',
    148: 'Soft Space',
    149: 'Dock Triangle',
    150: 'Dock Square',
    151: 'Dock Pentagon',
    152: 'Dock Hexagon',
    153: 'Relic Epic Quality',
    154: 'Relic Legendary Quality',
    155: 'Not',
    156: 'Fate',
    157: 'Robot',
    158: 'Deep Hotel Card',
    159: 'Stem Hotel Card',
    160: 'Hex Hotel Card',
    161: 'Dread Hotel Card',
    162: 'Honored Hotel Card',
    163: 'Seed Hotel Card',
    164: 'Ghost Wave',
    165: 'Shift One',
    166: 'Shift Two',
    167: 'Shift Three',
    168: 'Time',
    169: 'Deep Freighter',
    170: 'Stem Freighter',
    171: 'Hex Freighter',
    172: 'Dread Freighter',
    173: 'Honored Freighter',
    174: 'Seed Freighter',
    175: 'Deep Refugee',
    176: 'Stem Refugee',
    177: 'Hex Refugee',
    178: 'Dread Refugee',
    179: 'Honored Refugee',
    180: 'Seed Refugee',
    181: 'Deep Aristocrat',
    182: 'Stem Aristocrat',
    183: 'Hex Aristocrat',
    184: 'Dread Aristocrat',
    185: 'Honored Aristocrat',
    186: 'Seed Aristocrat',
    187: 'Deep Crowd',
    188: 'Stem Crowd',
    189: 'Hex Crowd',
    190: 'Dread Crowd',
    191: 'Honored Crowd',
    192: 'Seed Crowd',
    193: 'Deep Freelancer',
    194: 'Stem Freelancer',
    195: 'Hex Freelancer',
    196: 'Dread Freelancer',
    197: 'Honored Freelancer',
    198: 'Seed Freelancer',
    199: 'Upgraded Battery',
    200: 'Battery',
    201: 'Upgraded Ghost Handler',
    202: 'Ghost Handler',
    203: 'Miysst',
    204: 'Amenities',
    205: 'Beds',
    206: 'CoreRooms',
    207: 'Guests',
    208: 'Faction',
    209: 'Guilds',
    210: 'Science Academy',
    211: 'Gambling Commission',
    212: 'Actors Guild',
    213: 'Bar Association',
    214: 'The Church',
    215: 'Seeker Society',
    216: 'Hotel',
    217: 'Guest',
    218: 'GuestShip',
    219: 'Intelligence',
    220: 'Charisma',
    221: 'Dexterity',
    222: 'Tourists',
    223: 'Deep Tourist',
    224: 'Stem Tourist',
    225: 'Hex Tourist',
    226: 'Dread Tourist',
    227: 'Honored Tourist',
    228: 'Seed Tourist',
    229: 'Orbit',
    230: 'Reception',
    231: 'Bridge',
    232: 'Activity Station',
    233: 'Map',
    234: 'Vault',
    235: 'Captains',
    236: 'Teleport',
    237: 'Dock',
    238: 'Experience',
    239: 'Neuron',
    240: 'Quests',
    241: 'Campaigns',
    242: 'No',
    243: 'Yes',
    244: 'Redacted',
    245: 'Vacancy',
    246: 'Pickup',
    247: 'Tempest',
    248: 'Room Service',
    249: 'Trolley',
    250: 'Permit',
    251: 'Lodgings',
    252: 'Ghast',
    253: 'Void',
    254: 'Ank Cur',
    255: 'Lur Cur',
    256: 'Ley Lane',
    257: 'Ley Line',
    258: 'Ley Lumen',
};

// Returns the player-facing name for a TName id, or null when the id is
// falsy / unknown. Callers strip categorical prefixes for caption copy.
export function getTextureName(tname) {
    return TEXTURE_NAMES[tname] || null;
}
